import LocationsTable from '../../settings/LocationsTable';

const Locations = () => {
  return (
    <div className="dashboard-container">
        <h2>Locaties</h2>
        <LocationsTable />
    </div>
  )
}

export default Locations
